import { NgModule } from '@angular/core'
import { Routes, RouterModule, PreloadAllModules } from '@angular/router'

const routes: Routes = [
  {
    path: 'projects',
    loadChildren: () => import('@app/project/project.module').then(m => m.ProjectModule),
  },
  {
    path: 'unit',
    loadChildren: () => import('@app/ahu/ahu.module').then(m => m.AhuModule),
  },
  {
    path: '',
    redirectTo: '/projects',
    pathMatch: 'full',
  },
  {
    path: 'hex',
    loadChildren: () => import('./hex-calculation/hex-calculation.module').then(m => m.HexCalculationModule),
  },
  {
    path: '**',
    redirectTo: '/projects',
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
